export default __webpack_public_path__ + "static/Orthopedic Mattresses for Back Pain-421abe13e1dfafe659498d2fb3b6ce37.jpg";